import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { sendEvent } from '@upr-web-primer/app-utils';
import * as i4 from '@upr-web-primer/gds-common-utility';
import * as i1 from '@upr-web-primer/gds-filter-list';
import * as i2 from '@upr-web-primer/gds-modal';
import * as i3 from '@upr-web-primer/gds-route-resolver';
import { get } from 'lodash-es';

class GdsButtonEventsModule {
}
GdsButtonEventsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsButtonEventsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
GdsButtonEventsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsButtonEventsModule });
GdsButtonEventsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsButtonEventsModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsButtonEventsModule, decorators: [{
            type: NgModule,
            args: [{}]
        }] });

class GdsButtonEventsService {
    constructor(document, gdsFilterListService, gdsModalService, routeResolver, utilities) {
        this.document = document;
        this.gdsFilterListService = gdsFilterListService;
        this.gdsModalService = gdsModalService;
        this.routeResolver = routeResolver;
        this.utilities = utilities;
    }
    buttonClickHandler(event, eventData = {}) {
        const el = event.target;
        const rawBtnData = this.utilities.getComponentData(el);
        const btnData = get(rawBtnData, 'button', rawBtnData);
        if (!btnData)
            return;
        const btnType = get(btnData, 'type') || get(event, 'detail.data.background.link.type');
        if (btnType === 'right-arrow' || btnType === 'left-arrow')
            return;
        const { content, contentType, theme, viewContainerRef } = eventData;
        const btnHref = get(btnData, 'href');
        const btnTarget = get(btnData, 'target') ||
            get(event, 'detail.data.background.link.target');
        if (btnData?.customEventDetail?.type === 'filterResults') {
            this.gdsFilterListService.updateResults(btnData);
            return;
        }
        if (['open-filter', 'clear-filter'].includes(btnTarget)) {
            this.gdsFilterListService.accessFilters(btnData);
            return;
        }
        if (btnTarget === 'application') {
            const customEventDetailData = get(btnData, 'customEventDetail') ||
                get(content, 'buttons.EmbeddedValues[0].link.EmbeddedValues[0].Component.LinkedComponentValues[0].Fields.customEventDetail.EmbeddedValues') ||
                [];
            const customEventDetailObject = this.utilities.createObjectFromArray(customEventDetailData);
            this.utilities.applicationRequestHandler(customEventDetailObject);
            return;
        }
        if (this.utilities.isModal(btnTarget, btnType)) {
            this.gdsModalService.loadModal(btnData, content, this.utilities.getContrast(), event, theme || '', contentType !== 'dynamic', viewContainerRef);
            return;
        }
        if (btnTarget === 'map-modal') {
            sendEvent('OPEN_GDS_INTERACTIVE_MAP_GLOBAL', { href: btnHref });
            return;
        }
        if (btnData.card_type === 'full-image-card') {
            this.routeResolver.resolveRoute(get(event, 'detail.data.background.link'));
            return;
        }
        if (btnTarget === 'privacy') {
            this.openPrivacyModal(el);
            return;
        }
        this.routeResolver.resolveRoute(btnData);
    }
    openPrivacyModal(btnEl) {
        const privacyModal = this.document.querySelector('#onetrust-pc-sdk');
        const isModalVisible = privacyModal?.offsetWidth ||
            privacyModal?.offsetHeight ||
            privacyModal?.getClientRects()?.length;
        if (privacyModal && !isModalVisible) {
            const privacyClicker = btnEl?.querySelector('.ot-sdk-show-settings');
            privacyModal && privacyClicker?.click();
        }
    }
}
GdsButtonEventsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsButtonEventsService, deps: [{ token: DOCUMENT }, { token: i1.GdsFilterListService }, { token: i2.GdsModalService }, { token: i3.GdsRouteResolverService }, { token: i4.GdsCommonUtilityService }], target: i0.ɵɵFactoryTarget.Injectable });
GdsButtonEventsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsButtonEventsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: GdsButtonEventsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i1.GdsFilterListService }, { type: i2.GdsModalService }, { type: i3.GdsRouteResolverService }, { type: i4.GdsCommonUtilityService }]; } });

export { GdsButtonEventsModule, GdsButtonEventsService };
